import { getProductsByKey } from '@/apis/base';

export default {
  namespaced: true,
  state: () => {
    return {
      key: '',
      productList: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
    };
  },
  getters: {
    pageInfo (state) {
      return {
        pageIndex: parseInt(state.pageInfo.pageIndex),
        pageSize: parseInt(state.pageInfo.pageSize),
        total: parseInt(state.pageInfo.total)
      };
    }
  },
  actions: {
    async setProducts ({commit, state, getters}) {
      const pageInfo = getters.pageInfo;
      let res = await getProductsByKey(
        state.key,
        pageInfo.pageIndex,
        pageInfo.pageSize
      );
      const data = res._data;
      commit('setProducts', data.productList);
      commit('setPageInfo', data.pageInfo);
    },
    async setMoreProducts ({commit, state, getters}) {
      const pageInfo = getters.pageInfo;
      let res = await getProductsByKey(
        state.key,
        pageInfo.pageIndex + 1,
        pageInfo.pageSize
      );
      const data = res._data;
      commit('setProducts', state.productList.concat(data.productList));
      commit('setPageInfo', data.pageInfo);
    },
    setKey ({commit, state, dispatch}, payload) {
      commit('setKey', payload);
      commit('setPageInfo', {
        ...state.pageInfo,
        pageIndex: 1,
        total: 0
      });
      dispatch('setProducts');
    },
    setPageInfo ({commit}, payload) {
      commit('setPageInfo', payload);
    }
  },
  mutations: {
    setProducts (state, payload) {
      state.productList = payload;
    },
    setKey (state, payload) {
      state.key = payload;
    },
    setPageInfo (state, payload) {
      state.pageInfo = payload;
    }
  }
};
